module.exports = {"350525100":"桃城镇","350525101":"五里街镇","350525102":"一都镇","350525103":"下洋镇","350525104":"蓬壶镇","350525105":"达埔镇","350525106":"吾峰镇","350525107":"石鼓镇","350525108":"岵山镇","350525109":"东平镇","350525110":"湖洋镇","350525111":"坑仔口镇","350525112":"玉斗镇","350525113":"锦斗镇","350525114":"东关镇","350525115":"桂洋镇","350525116":"苏坑镇","350525117":"仙夹镇","350525200":"横口乡","350525201":"呈祥乡","350525202":"介福乡","350525204":"外山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350525.json
// module id = 1204
// module chunks = 0